module.exports = __webpack_public_path__ + "assets/img/message.84cef555.svg";